import './vendor/polyfill/ie'
import './apps/bankrate-cookie'
import './rebrand/homepage/tracking'
import './apps/bankrate-ga-dataLayer'
import Vue from 'vue'
import OARate from './apps/bankrate-homepage/components/oa-rate-rebrand.vue'
import MultiChart from './apps/bankrate-homepage/components/multi-trends-chart-rebrand.vue'
import EmailCaptureForm from './apps/components/email-capture-form-v2'

Vue.component('multi-chart', MultiChart)
Vue.component('oa-rate', OARate)

if (document.querySelector('#multiCharts') !== null) {
  new Vue({
    el: '#multiCharts'
  })
}

if (document.getElementById('email-capture-form')) {
  new Vue({
    el: '#email-capture-form',
    components: {
      EmailCaptureForm
    }
  })
}
